import React from 'react';
import { Activity, Clock, History, User, Users } from 'lucide-react';
import { FilterDef, SortDef, DefaultSort } from '@/components/shared/filters';

interface RepOption {
  value: string;
  label: string;
}

export const buildVisitorFilters = (repOptions: RepOption[]): FilterDef[] => [
  {
    id: 'status',
    label: 'Status',
    icon: <Activity className="h-3.5 w-3.5" />,
    type: 'multiselect',
    urlParam: 'status',
    pinned: true,
    options: [
      { value: 'onsite', label: 'Onsite' },
      { value: 'in_app', label: 'In-app' },
      { value: 'web_session', label: 'Web session' },
      { value: 'app_session', label: 'App session' },
      { value: 'offline', label: 'Offline' },
    ],
  },
  {
    id: 'lastSeen',
    label: 'Last Seen',
    icon: <Clock className="h-3.5 w-3.5" />,
    type: 'select',
    urlParam: 'last_seen_filter',
    options: [
      { value: 'all', label: 'All Time' },
      { value: 'today', label: 'Today' },
      { value: 'last7days', label: 'Last 7 Days' },
      { value: 'last30days', label: 'Last 30 Days' },
    ],
  },
  {
    id: 'firstSeen',
    label: 'First Seen',
    icon: <Clock className="h-3.5 w-3.5" />,
    type: 'select',
    urlParam: 'first_seen_filter',
    options: [
      { value: 'all', label: 'All Time' },
      { value: 'today', label: 'Today' },
      { value: 'last7days', label: 'Last 7 Days' },
      { value: 'last30days', label: 'Last 30 Days' },
    ],
  },
  {
    id: 'identity',
    label: 'Identity',
    icon: <User className="h-3.5 w-3.5" />,
    type: 'select',
    urlParam: 'identity_type',
    options: [
      { value: 'all', label: 'All identities' },
      { value: 'contact', label: 'Contact' },
      { value: 'identified', label: 'Identified' },
      { value: 'anonymous', label: 'Anonymous' },
    ],
  },
  {
    id: 'history',
    label: 'Session history',
    icon: <History className="h-3.5 w-3.5" />,
    type: 'select',
    urlParam: 'has_conversation_history',
    options: [
      { value: 'all', label: 'Any history' },
      { value: 'true', label: 'Has history' },
      { value: 'false', label: 'No history' },
    ],
  },
  ...(repOptions.length ? [{
    id: 'reps',
    label: 'Rep',
    icon: <Users className="h-3.5 w-3.5" />,
    type: 'multiselect' as const,
    urlParam: 'human_agent_ids',
    searchable: true,
    options: repOptions,
  }] : []),
];

export const VISITOR_SORTS: SortDef[] = [
  { id: 'lastSeen', label: 'Last seen', field: 'last_seen_at', defaultOrder: 'desc' },
  { id: 'firstSeen', label: 'First seen', field: 'first_seen_at', defaultOrder: 'desc' },
  { id: 'conversationCount', label: 'Conversation count', field: 'conversation_count', defaultOrder: 'desc' },
];

export const VISITOR_DEFAULT_SORT: DefaultSort = { field: 'last_seen_at', order: 'desc' };
